export default {
	title: "American Association for Physician Leadership | AAPL",
	description:
		"The American Association for Physician Leadership (AAPL), formerly known as the American College of Physician Executives (ACPE), is the premier organization for online and live CME-earning courses, conferences, and career coaching & services. Learn more about how to earn a CPE credential with us.",
	openGraph: {
		type: "website",
		locale: "en_US",
		url: "https://www.physicianleaders.org",
		site_name: "American Association for Physician Leadership - Inspiring Change. Together",
		images: [
			{
				// url: `https://images.ctfassets.net/mdag2z2o3c18/n1Xz5taBj9gENh0SEfBLp/8642ba9f6c26374f63fa0e6efb8ea513/AAPL-logo.svg?fit=scale&w=150`,
				url: `https://images.ctfassets.net/mdag2z2o3c18/73533DQHZgyUDdrQ0j4iwo/d2ac1fd3ae5f15103e3ce6f107e3d7cb/aapl-logo.png`,
			},
		],
	},
	twitter: {
		handle: "@physicianslead",
		site: "https://www.twitter.com/physicianslead",
		cardType: "summary",
	},
};
